import React from 'react';
import Modal from './Modal';

// Инструкция, как «установить» приложение с помощью браузера
const platforms = [
  {
    name: '🍎 Safari (iPhone / iPad)',
    steps: [
      'Открой сайт Копилки в браузере Safari.',
      'Нажми кнопку «Поделиться» — квадрат со стрелкой вверх в нижней панели.',
      'В появившемся меню выбери «На экран “Домой”».',
      'Нажми «Добавить» в правом верхнем углу.',
      'На главном экране появится иконка — приложение будет запускаться как обычное.'
    ]
  },
  {
    name: '▶️ Google Chrome (Android / компьютер)',
    steps: [
      'Открой сайт Копилки в Chrome.',
      'На Android: нажми ⋮ (три точки) справа сверху → «Добавить на главный экран» → «Установить».',
      'На компьютере: нажми ⋮ → «Установить “Копилку”…» → «Установить».',
      'Ярлык появится на рабочем столе — приложение откроется отдельным окном.'
    ]
  },
  {
    name: '🦊 Firefox (Android / компьютер)',
    steps: [
      'Открой сайт Копилки в Firefox.',
      'Нажми ☰ (меню) в правом верхнем углу.',
      'На Android: выбери «Добавить на главный экран» → «Добавить».',
      'На компьютере: выбери «Установить» и подтверди.',
      'Приложение появится на рабочем столе или в меню приложений.'
    ]
  }
];

export default function InstallModal({ onClose }) {
  return (
    <Modal title="Как установить приложение" onClose={onClose}>
      <p className="modal-intro">
        Магазины приложений не нужны — Копилка работает прямо в браузере. Просто добавь сайт на главный экран:
      </p>
      {platforms.map(p => (
        <div key={p.name} className="install-block">
          <h4>{p.name}</h4>
          <ol>
            {p.steps.map((s, i) => <li key={i}>{s}</li>)}
          </ol>
        </div>
      ))}
    </Modal>
  );
}
